import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

const BlockDisplay = () => {
    const { open } = useSelector((state) => state.blockDisplayState);
    return (
        <Backdrop style={{ zIndex: 9999 }} open={open}>
            <CircularProgress color='inherit' />
        </Backdrop>
    );
};

export default BlockDisplay;
